/** Parse "1000:5,1000000:2,*:1" (whole units : basis points) for a token with `decimals`. */
export function parseSendFeeBands(text, decimals) {
    const unit = 10n ** BigInt(decimals);
    const bands = text.split(',').map((part) => {
        const [limit = '', rate = ''] = part.trim().split(':');
        const bps = Number(rate);
        if (!Number.isInteger(bps) || bps < 0 || bps > 1000)
            throw new Error(`Bad send fee band "${part}": the rate is whole basis points, 0 to 1000`);
        if (limit === '*')
            return [null, bps];
        if (!/^\d+$/.test(limit))
            throw new Error(`Bad send fee band "${part}"`);
        return [(BigInt(limit) * unit).toString(), bps];
    });
    if (bands.at(-1)?.[0] !== null)
        throw new Error('The last send fee band must be "*:<rate>"');
    for (let i = 1; i < bands.length - 1; i += 1) {
        if (BigInt(bands[i]?.[0] ?? '0') <= BigInt(bands[i - 1]?.[0] ?? '0'))
            throw new Error('Send fee bands must rise');
    }
    return bands;
}
/** The fee on sending `amount`, before any account-opening addition. */
export function sendFee(amount, schedule) {
    if (amount <= 0n)
        return 0n;
    if (schedule.bands.every(([, bps]) => bps === 0))
        return 0n;
    let fee = 0n;
    let from = 0n;
    for (const [limit, bps] of schedule.bands) {
        const to = limit === null ? amount : BigInt(limit) < amount ? BigInt(limit) : amount;
        if (to > from)
            fee += ((to - from) * BigInt(bps)) / 10000n;
        from = to;
        if (from >= amount)
            break;
    }
    const min = BigInt(schedule.min);
    return fee < min ? min : fee;
}
//# sourceMappingURL=send-fee.js.map